import styled from 'styled-components';

import { Text } from '@gympass/yoga';
import { AlertTriangle } from '@gympass/yoga-icons';

import { Button } from 'components/Button';

export const ConfirmationStep = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: space-between;
`;

export const InfoContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;

export const ButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const StyledAlertTriangle = styled(AlertTriangle)`
  width: ${({ theme }) => theme.yoga.spacing.xxlarge}px;
  height: ${({ theme }) => theme.yoga.spacing.xxlarge}px;
  fill: ${({ theme }) => theme.yoga.colors.secondary} !important;
  margin-top: ${({ theme }) => theme.yoga.spacing.small}px;
`;

export const ConfirmationMessage = styled(Text.Regular)`
  margin-top: ${({ theme }) => theme.yoga.spacing.small}px;
  color: ${({ theme }) => theme.yoga.colors.text.disabled};
`;

export const ConfirmationButton = styled(props => <Button {...props} />)`
  border-radius: ${({ theme }) => theme.yoga.radii.large}px;
  padding: ${({ theme }) => theme.yoga.spacing.xsmall}px
    ${({ theme }) => theme.yoga.spacing.large}px;
  font-size: ${({ theme }) => theme.yoga.fontSizes.medium}px;
  line-height: ${({ theme }) => theme.yoga.lineHeights.xsmall}px;
  margin-right: ${({ theme }) => theme.yoga.spacing.xxxxlarge}px;
`;
